export default __webpack_public_path__ + "static/media/icon_facial_details.e01f385e.png";